// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Контейнер секции */
.MissionSection_missionContainer__AfVPt {
  padding: 3rem 1.5rem;
  background: linear-gradient(to right, #fffbf1, #ffe8e8);
  border-radius: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  text-align: center;
}

/* Заголовок секции */
.MissionSection_title__agEyd {
  font-family: "Ysabeau SC", sans-serif;
  font-size: 2.5rem;
  color: #b31a1a;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
}

/* Вступительный текст */
.MissionSection_intro__3sxpe {
  font-family: "Open Sans", sans-serif;
  font-size: 1.2rem;
  color: #333;
  margin-bottom: 2rem;
  line-height: 1.6;
}

/* Контейнер целей */
.MissionSection_goals__47tv3 {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
}

/* Каждая цель */
.MissionSection_goal__ZN2tB {
  width: 300px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;
  display: flex;
  flex-direction: column; /* Ставим элементы по вертикали */
  justify-content: space-between; /* Равномерное распределение */
  align-items: center; /* Центрируем элементы */
}

.MissionSection_goal__ZN2tB:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

/* Заголовок цели */
.MissionSection_goalTitle__81\\+DL {
  font-family: "Ysabeau SC", sans-serif;
  font-size: 1.5rem;
  color: #b31a1a;
  margin-bottom: 1rem;
}

/* Описание цели */
.MissionSection_goalText__mWmIZ {
  font-family: "Open Sans", sans-serif;
  font-size: 1rem;
  color: #555;
  line-height: 1.6;
  margin-bottom: 1rem; /* Отступ перед иконкой */
}

/* Иконки */
.MissionSection_icon__Xs16K {
  font-size: 2.5rem; /* Размер иконки */
  color: #b31a1a;
  margin-top: 1rem; /* Отступ сверху */
}

/* Адаптивность */
@media (max-width: 768px) {
  .MissionSection_missionContainer__AfVPt {
    padding: 2rem 1rem;
  }

  .MissionSection_title__agEyd {
    font-size: 2rem;
  }

  .MissionSection_goal__ZN2tB {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/mainPage/MissionSection/MissionSection.module.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,oBAAoB;EACpB,uDAAuD;EACvD,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,oCAAoC;EACpC,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;EACf,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,sBAAsB,EAAE,iCAAiC;EACzD,8BAA8B,EAAE,8BAA8B;EAC9D,mBAAmB,EAAE,wBAAwB;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,mBAAmB;AACnB;EACE,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,oCAAoC;EACpC,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB,EAAE,yBAAyB;AAChD;;AAEA,WAAW;AACX;EACE,iBAAiB,EAAE,kBAAkB;EACrC,cAAc;EACd,gBAAgB,EAAE,kBAAkB;AACtC;;AAEA,iBAAiB;AACjB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Контейнер секции */\r\n.missionContainer {\r\n  padding: 3rem 1.5rem;\r\n  background: linear-gradient(to right, #fffbf1, #ffe8e8);\r\n  border-radius: 20px;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\r\n  text-align: center;\r\n}\r\n\r\n/* Заголовок секции */\r\n.title {\r\n  font-family: \"Ysabeau SC\", sans-serif;\r\n  font-size: 2.5rem;\r\n  color: #b31a1a;\r\n  margin-bottom: 1.5rem;\r\n  text-transform: uppercase;\r\n}\r\n\r\n/* Вступительный текст */\r\n.intro {\r\n  font-family: \"Open Sans\", sans-serif;\r\n  font-size: 1.2rem;\r\n  color: #333;\r\n  margin-bottom: 2rem;\r\n  line-height: 1.6;\r\n}\r\n\r\n/* Контейнер целей */\r\n.goals {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n  gap: 2rem;\r\n}\r\n\r\n/* Каждая цель */\r\n.goal {\r\n  width: 300px;\r\n  background-color: #fff;\r\n  border-radius: 15px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  padding: 1.5rem;\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n  text-align: center;\r\n  display: flex;\r\n  flex-direction: column; /* Ставим элементы по вертикали */\r\n  justify-content: space-between; /* Равномерное распределение */\r\n  align-items: center; /* Центрируем элементы */\r\n}\r\n\r\n.goal:hover {\r\n  transform: translateY(-5px);\r\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n/* Заголовок цели */\r\n.goalTitle {\r\n  font-family: \"Ysabeau SC\", sans-serif;\r\n  font-size: 1.5rem;\r\n  color: #b31a1a;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n/* Описание цели */\r\n.goalText {\r\n  font-family: \"Open Sans\", sans-serif;\r\n  font-size: 1rem;\r\n  color: #555;\r\n  line-height: 1.6;\r\n  margin-bottom: 1rem; /* Отступ перед иконкой */\r\n}\r\n\r\n/* Иконки */\r\n.icon {\r\n  font-size: 2.5rem; /* Размер иконки */\r\n  color: #b31a1a;\r\n  margin-top: 1rem; /* Отступ сверху */\r\n}\r\n\r\n/* Адаптивность */\r\n@media (max-width: 768px) {\r\n  .missionContainer {\r\n    padding: 2rem 1rem;\r\n  }\r\n\r\n  .title {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .goal {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"missionContainer": `MissionSection_missionContainer__AfVPt`,
	"title": `MissionSection_title__agEyd`,
	"intro": `MissionSection_intro__3sxpe`,
	"goals": `MissionSection_goals__47tv3`,
	"goal": `MissionSection_goal__ZN2tB`,
	"goalTitle": `MissionSection_goalTitle__81+DL`,
	"goalText": `MissionSection_goalText__mWmIZ`,
	"icon": `MissionSection_icon__Xs16K`
};
export default ___CSS_LOADER_EXPORT___;
